module.exports = __webpack_public_path__ + "img/img (27).30c93cff.jpg";